import { ManagerClubRegularDto, SysCfgRegularDto } from "@/shared/api";

//////////Managers
export interface ClubManager {
  id: string;
  name: string;
  auth_groups: Set<string>;
  created_at: string; // ISO 8601 date string
  updated_at: string; // ISO 8601 date string
  enabled: boolean;
  data: {
    username: string;
    clubs: ClubWithEnabled[];
  };
}

export interface Club {
  cid: string;
  aid: string;
  group: string;
  level: {
    enabled: boolean;
    threshold: number;
  };
  kickout: {
    low_gold: ThresholdConfig;
    inactive: ThresholdConfig;
    unauthorized: ThresholdConfig;
  };
  alc: {
    distribute: ThresholdConfig;
  };
  gold: {
    buy: GoldBuyConfig;
    distribute: ThresholdConfig;
  };
  gems: {
    enabled: boolean;
    threshold: number;
  };
}

export interface ClubWithEnabled extends Club {
  enabled: boolean;
  cid: string;
  aid: string;
  group: string;
  level: {
    enabled: boolean;
    threshold: number;
  };
  kickout: {
    low_gold: ThresholdConfig;
    inactive: ThresholdConfig;
    unauthorized: ThresholdConfig;
  };
  alc: {
    distribute: ThresholdConfig;
  };
  gold: {
    buy: GoldBuyConfig;
    distribute: ThresholdConfig;
  };
  gems: {
    enabled: boolean;
    threshold: number;
  };
}

interface ThresholdConfig {
  enabled: boolean;
  threshold: number;
}

interface GoldBuyConfig extends ThresholdConfig {
  packs: number;
}
/////////

export interface EnrichedClub extends SysCfgRegularDto, Club /*ClubManager*/ /*Partial<Omit<ClubManager, "data">>*/ {
  id: string;
  name: string;
  auth_groups: Set<string>;
  created_at: string;
  updated_at: string;
  enabled: boolean;
  username?: string;
  data?: ClubWithEnabled[];
  clubEnabled?: boolean; //shows club status

  //from redis
  club_data_from_redis: {
    name?: string;
    username?: string;
    player_id?: string;
    group_id?: string;
    club_id?: string;
    internal_club_id?: string;
    alliance_id?: string;
    internal_alliance_id?: string;
    gold?: number;
    gems?: number;
    alc_balance?: number;
    is_gold?: boolean;
    club_level?: number;
    max_members?: number;
    cur_members?: number;
    updated_at?: number;
  }
}


export const enrichClubManagerNewWithClubData = (  //for manager
  roomConfigsData: SysCfgRegularDto[],
  clubConfigsData: ManagerClubRegularDto[]
): EnrichedClub[] => {
  return roomConfigsData.map((config) => {


    const generalData = (config as unknown as ClubManager)

    const clubData: ClubWithEnabled[] = generalData.data.clubs;
    const enrichedClub = clubData.map((club, index) => {

      const ccd = clubConfigsData.find((ccd) => ccd.club_id === club.cid && ccd.username === generalData?.data.username);

      // Убираем поле enabled из club с помощью деструктуризации
      const { enabled, ...clubWithoutEnabled } = club;

      return {
        id: generalData?.id ?? " ",
        name: generalData?.name,
        displayableName: generalData?.name.concat(`-(${index})`) ?? " ", //Name with index for showing some clubs
        auth_groups: new Set(generalData?.auth_groups) ?? new Set<string>(),
        created_at: generalData?.created_at,
        updated_at: generalData?.updated_at,
        enabled: generalData?.enabled ?? false,
        username: generalData?.data?.username,

        ...clubWithoutEnabled,
        club_data_from_redis: {
          ...ccd,
        },
        clubEnabled: club?.enabled,
      } as EnrichedClub
    });

    return enrichedClub;
  }).flat();

};